// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__3wUUe"};